import * as XLSX from 'xlsx';

// Download Excel template for motorcycles from backend
export const downloadMotorcycleTemplate = async () => {
  try {
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    
    const response = await fetch(`${API}/api/motorcycles/bulk-upload-template`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to download template');
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Motorcycle_Bulk_Upload_Template.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading template:', error);
    alert('Failed to download template. Please try again.');
  }
};

// Generate Excel template for riders
export const downloadRiderTemplate = () => {
  const template = [
    {
      name: 'John Doe',
      date_of_birth: '1990-01-01',
      emirates_id: '784-1234-1234567-1',
      emirates_id_expiry: '2025-12-31',
      passport_number: 'A12345678',
      passport_expiry: '2026-12-31',
      license_number: 'DL123456',
      license_expiry: '2025-06-30',
      mobile_uae: '+971501234567',
      email: 'john.doe@example.com',
      platform: 'Talabat',
      lessee_name: 'ABC Company (optional)',
      status: 'active'
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(template);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Riders Template');
  
  // Add column widths
  worksheet['!cols'] = [
    { wch: 20 }, // name
    { wch: 15 }, // date_of_birth
    { wch: 22 }, // emirates_id
    { wch: 18 }, // emirates_id_expiry
    { wch: 18 }, // passport_number
    { wch: 18 }, // passport_expiry
    { wch: 15 }, // license_number
    { wch: 18 }, // license_expiry
    { wch: 18 }, // mobile_uae
    { wch: 25 }, // email
    { wch: 15 }, // platform
    { wch: 25 }, // lessee_name
    { wch: 12 }  // status
  ];
  
  XLSX.writeFile(workbook, 'Riders_Bulk_Upload_Template.xlsx');
};

// Generate Excel template for batteries
export const downloadBatteryTemplate = () => {
  const template = [
    {
      battery_id: 'BAT-001',
      serial_number: 'SN123456789',
      capacity_ah: 60,
      status: 'available',
      health_percentage: 100
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(template);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Batteries Template');
  
  // Add column widths
  worksheet['!cols'] = [
    { wch: 15 }, // battery_id
    { wch: 20 }, // serial_number
    { wch: 15 }, // capacity_ah
    { wch: 15 }, // status
    { wch: 18 }  // health_percentage
  ];
  
  XLSX.writeFile(workbook, 'Batteries_Bulk_Upload_Template.xlsx');
};

// Generate Excel template for Salik records
export const downloadSalikTemplate = () => {
  const template = [
    {
      salik_date: '2024-01-15',
      salik_time: '14:30',
      bike_plate_number: 'ABC-1234',
      salik_gate_name: 'Al Maktoum Bridge',
      amount: 4.00
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(template);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Salik Template');
  
  // Add column widths
  worksheet['!cols'] = [
    { wch: 15 }, // salik_date
    { wch: 12 }, // salik_time
    { wch: 18 }, // bike_plate_number
    { wch: 25 }, // salik_gate_name
    { wch: 12 }  // amount
  ];
  
  XLSX.writeFile(workbook, 'Salik_Bulk_Upload_Template.xlsx');
};

// Generate Excel template for Fines
export const downloadFineTemplate = () => {
  const template = [
    {
      fine_date: '2024-01-15',
      fine_time: '10:30',
      bike_plate_number: 'ABC-1234',
      amount: 500.00,
      admin_fees: 20.00,
      reason: 'Speeding violation'
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(template);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Fines Template');
  
  // Add column widths
  worksheet['!cols'] = [
    { wch: 15 }, // fine_date
    { wch: 12 }, // fine_time
    { wch: 18 }, // bike_plate_number
    { wch: 12 }, // amount
    { wch: 12 }, // admin_fees
    { wch: 40 }  // reason
  ];
  
  XLSX.writeFile(workbook, 'Fines_Bulk_Upload_Template.xlsx');
};

// Generate Excel template for repair items
export const downloadRepairItemTemplate = () => {
  const template = [
    {
      item_code: 'BRK-001',
      category: 'brake',
      description: 'Front brake pad replacement set',
      rate: 150.00
    },
    {
      item_code: 'ENG-001',
      category: 'engine',
      description: 'Engine oil change and filter replacement',
      rate: 80.00
    },
    {
      item_code: 'ELEC-001',
      category: 'electrical',
      description: 'Headlight bulb replacement',
      rate: 50.00
    },
    {
      item_code: 'TIRE-001',
      category: 'tire',
      description: 'Front tire replacement',
      rate: 120.00
    },
    {
      item_code: 'SPEC-001',
      category: 'special_items',
      description: 'Custom repair - describe the non-standard work',
      rate: 200.00
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(template);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Repair Items Template');
  
  // Add column widths
  worksheet['!cols'] = [
    { wch: 15 }, // item_code
    { wch: 18 }, // category
    { wch: 50 }, // description
    { wch: 12 }  // rate
  ];
  
  XLSX.writeFile(workbook, 'Repair_Items_Bulk_Upload_Template.xlsx');
};

// Generate Excel template for Battery Swaps
export const downloadBatterySwapTemplate = () => {
  const template = [
    {
      swap_date: '2024-01-15',
      swap_time: '14:30',
      bike_plate_number: 'ABC-1234',
      rider_name: 'John Doe',
      rider_emirates_id: '784-1234-1234567-1',
      odo_reading: 1500.5,
      return_battery1_serial: 'SN123456789',
      return_battery1_soc: 25,
      return_battery2_serial: 'SN987654321',
      return_battery2_soc: 30,
      issued_battery1_serial: 'SN111222333',
      issued_battery1_soc: 100,
      issued_battery2_serial: 'SN444555666',
      issued_battery2_soc: 100,
      location: 'Al Barsha Swap Station',
      notes: 'Regular battery swap'
    }
  ];

  const worksheet = XLSX.utils.json_to_sheet(template);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Battery Swaps Template');
  
  // Add column widths
  worksheet['!cols'] = [
    { wch: 15 }, // swap_date
    { wch: 12 }, // swap_time
    { wch: 18 }, // bike_plate_number
    { wch: 20 }, // rider_name
    { wch: 22 }, // rider_emirates_id
    { wch: 15 }, // odo_reading
    { wch: 20 }, // return_battery1_serial
    { wch: 18 }, // return_battery1_soc
    { wch: 20 }, // return_battery2_serial
    { wch: 18 }, // return_battery2_soc
    { wch: 20 }, // issued_battery1_serial
    { wch: 18 }, // issued_battery1_soc
    { wch: 20 }, // issued_battery2_serial
    { wch: 18 }, // issued_battery2_soc
    { wch: 25 }, // location
    { wch: 30 }  // notes
  ];
  
  XLSX.writeFile(workbook, 'Battery_Swaps_Bulk_Upload_Template.xlsx');
};

// Parse uploaded Excel file
export const parseExcelFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
        resolve(jsonData);
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = () => reject(new Error('Failed to read file'));
    reader.readAsArrayBuffer(file);
  });
};
